import React from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { Button } from "./ui";

const mapBtnClassToButton = (btnClass, isViewBranch) => {
  switch (btnClass) {
    case "ocean":
    case "primary":
      return { color: "primary" };
    case "secondary":
      return { color: "primary", outline: true };
    case "accept-orders":
    case "success":
      return { color: "success" };
    case "reject-orders":
      return isViewBranch
        ? { color: "danger", outline: true }
        : { color: "danger" };
    case "danger":
      return { color: "danger" };
    case "sound-on":
    case "warning":
    case "enable-notifications":
      return { color: "warning" };
    case "sound-off":
      return { color: "secondary", outline: true };
    default:
      return { color: "primary" };
  }
};

const Actionbar = ({
  firstBtnOnClick,
  firstBtnText,
  firstBtnClass = "primary",
  firstBtnIcon = "plus",
  secondBtnOnClick,
  secondBtnText,
  secondBtnClass = "secondary",
  secondBtnIcon = "refresh",
  thirdBtnOnClick,
  thirdBtnText,
  thirdBtnClass = "secondary",
  thirdBtnIcon = "refresh",
  title = "Quick Actions",
  subtitle = "Manage your workspace efficiently",
  disabledBtn1 = false,
  disabledBtn2 = false,
  disabledBtn3 = false,
  firstBtnTitle,
  secondBtnTitle,
  thirdBtnTitle,
  firstBtnTooltip = "",
  secondBtnTooltip = "",
  thirdBtnTooltip = "",
  isViewBranch = false,
  containerStyle,
}) => {
  const getIconSvg = (iconName) => {
    const icons = {
      plus: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      ),
      pen: (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 1.56066H1.5C1.23478 1.56066 0.98043 1.66602 0.792893 1.85355C0.605357 2.04109 0.5 2.29544 0.5 2.56066V9.56066C0.5 9.82588 0.605357 10.0802 0.792893 10.2678C0.98043 10.4553 1.23478 10.5607 1.5 10.5607H8.5C8.76522 10.5607 9.01957 10.4553 9.20711 10.2678C9.39464 10.0802 9.5 9.82588 9.5 9.56066V6.06066M8.75 0.81066C8.94891 0.611748 9.2187 0.5 9.5 0.5C9.7813 0.5 10.0511 0.611748 10.25 0.81066C10.4489 1.00957 10.5607 1.27936 10.5607 1.56066C10.5607 1.84196 10.4489 2.11175 10.25 2.31066L5.5 7.06066L3.5 7.56066L4 5.56066L8.75 0.81066Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      back: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      ),
      cross: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ),
      refresh: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="23 4 23 10 17 10" />
          <polyline points="1 20 1 14 7 14" />
          <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
      ),
      chart: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      ),
      check: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ),
      x: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ),
      save: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
          <polyline points="17 21 17 13 7 13 7 21" />
          <polyline points="7 3 7 8 15 8" />
        </svg>
      ),
      bell: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
          <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
        </svg>
      ),
      clock: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <polyline points="12 7 12 12 16 14" />
        </svg>
      ),
      maximize: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 3 21 3 21 9" />
          <polyline points="9 21 3 21 3 15" />
          <line x1="21" y1="3" x2="14" y2="10" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      ),
      speakerOn: (
        <svg className="oh-icon-directional" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M15 6.3706C15 4.65827 12.9884 3.73774 11.6926 4.85712L8.36317 7.73321C7.99988 8.04704 7.53583 8.21972 7.05576 8.21973L5.49998 8.21974C4.11928 8.21975 3 9.33903 3 10.7197V14.0127C3 15.3934 4.11929 16.5127 5.5 16.5127H7.0558C7.53587 16.5127 7.99993 16.6854 8.36322 16.9992L11.6926 19.8753C12.9884 20.9947 15 20.0741 15 18.3618V12.3662V6.3706Z" />
          <path d="M18 15.3672C18.6279 14.5315 19 13.4928 19 12.3672C19 11.2416 18.6279 10.2028 18 9.36719" strokeLinecap="round" />
          <path d="M20 18.3672C21.2558 16.6959 22 14.6184 22 12.3672C22 10.116 21.2558 8.03851 20 6.36719" strokeLinecap="round" />
        </svg>
      ),
      speakerOff: (
        <svg className="oh-icon-directional" width="16" height="16" viewBox="0 0 18 21" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13.75 11C13.75 10.5858 13.4142 10.25 13 10.25C12.5858 10.25 12.25 10.5858 12.25 11H13H13.75ZM9.40001 17.6226L9.89029 17.055L9.8799 17.046L9.86918 17.0374L9.40001 17.6226Z" fill="currentColor" />
          <path d="M17 3L2 18" strokeLinecap="round" />
        </svg>
      ),
      fileUpload: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      ),
      newchart: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      ),
    };
    return icons[iconName] || icons.plus;
  };

  const renderBarButton = ({
    visible,
    disabled,
    tooltipTitle,
    btnClass,
    onClick,
    iconName,
    btnText,
  }) => {
    if (!visible) return null;

    const variant = mapBtnClassToButton(btnClass, isViewBranch);
    const button = (
      <Button
        type="button"
        size={isViewBranch ? "table" : "sm"}
        color={variant.color}
        outline={variant.outline}
        disabled={disabled}
        onClick={onClick}
        icon={getIconSvg(iconName)}
      >
        {btnText}
      </Button>
    );

    if (disabled && tooltipTitle) {
      return (
        <MDBTooltip
          tag="span"
          title={tooltipTitle}
          placement="top"
          wrapperProps={{ className: "actionbar-btn-tooltip-wrap" }}
        >
          <span className="actionbar-btn-tooltip-wrap">{button}</span>
        </MDBTooltip>
      );
    }

    return button;
  };

  return (
    <div className="actionbar-container oh-actionbar" style={containerStyle}>
      <div className="actionbar-header oh-actionbar__header">
        <div
          className={`actionbar-icon oh-actionbar__icon${
            isViewBranch ? " oh-actionbar__icon--info actionbar-icon--info" : ""
          }`}
        >
          {getIconSvg(isViewBranch ? "newchart" : "chart")}
        </div>
        <div className="actionbar-title-section oh-actionbar__titles">
          <h2 className="actionbar-title oh-actionbar__title">{title}</h2>
          <p className="actionbar-subtitle oh-actionbar__subtitle">{subtitle}</p>
        </div>
      </div>

      <div className="actionbar-buttons oh-actionbar__buttons">
        {renderBarButton({
          visible: !!firstBtnText,
          disabled: disabledBtn1,
          tooltipTitle: firstBtnTooltip || firstBtnTitle,
          btnClass: firstBtnClass,
          onClick: firstBtnOnClick,
          iconName: firstBtnIcon,
          btnText: firstBtnText,
        })}
        {renderBarButton({
          visible: !!secondBtnText,
          disabled: disabledBtn2,
          tooltipTitle: secondBtnTooltip || secondBtnTitle,
          btnClass: secondBtnClass,
          onClick: secondBtnOnClick,
          iconName: secondBtnIcon,
          btnText: secondBtnText,
        })}
        {renderBarButton({
          visible: !!thirdBtnText,
          disabled: disabledBtn3,
          tooltipTitle: thirdBtnTooltip || thirdBtnTitle,
          btnClass: thirdBtnClass,
          onClick: thirdBtnOnClick,
          iconName: thirdBtnIcon,
          btnText: thirdBtnText,
        })}
      </div>
    </div>
  );
};

export default Actionbar;
